// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-blue-haven -> haven-realty-capital-blue-haven -> prosper-two-zero-seven
// Generated: 2026-11-04T21:37:37.063Z
// Counts: 6 design, 59 content, 28 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "VALUE",
    "value": "#0a0a0a",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Poppins', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Poppins', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Playfair Display', serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Poppins', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "discoveramenities.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Get to <span data-type=\"field-token\" data-field=\"property_name\"></span>?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Brand-New Apartments &amp; Townhomes for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "tabbedcallouts.section_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Find Your Space</strong></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourintro.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_virtualtours_blurb"
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility Statement</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments&amp; Townhomes with Modern Amenities in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Features Designed for Everyday Convenience</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 18px;\">We also offer guided tours with a leasing agent. Because most of our communities do not have an on-site agent, guided tours are by appointment only so the agent can confirm availability and commute time. Prospects cannot schedule these online — submit using our contact form below and a leasing agent will follow up to arrange your visit to <span data-type=\"field-token\" data-field=\"property_name\"></span>.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.guided_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Prefer a Guided Tour?</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Connect with Our Leasing Team</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.intro": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_contactus_blurb"
  },
  "contactform.self_guided_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 18px;\">Tour on your schedule—no agent required. Book online, get an access code by email, and open the lockbox when you arrive. We’ll check in before and after to answer questions and help with your application.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.self_guided_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Self-Guided Tours</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "discoveramenities.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Amenities Designed for You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Townhome and Apartment Floor Plans in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplansintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find the Floor Plan That Fits Your Needs</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span> Photo gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Closer Look at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "guidedtourcta.body": {
    "overrideType": "VALUE",
    "customValue": "<p>To request a guided tour, please submit via the contact form with your preferred date and time and we will be in touch ASAP to get you scheduled! Enabling text messages is a great option for quick communication. We will only text you to discuss your renting journey with us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/greystone-townhomes-with-pool-suwanee-ga::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover luxurious townhomes in Suwanee, GA, featuring a refreshing pool. Experience premium living in spacious homes with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/greystone-townhomes-with-pool-suwanee-ga::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Townhomes with Pool in Suwanee, GA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Townhomes &amp; Apartments In <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the <span data-type=\"field-token\" data-field=\"property_name\"></span> Neighborhood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-Friendly Apartments &amp; Townhomes in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h2>Dogs &amp; Cats Welcome</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Policy at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover the <span data-type=\"field-token\" data-field=\"property_address_city\"></span> Neighborhood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.disable_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.disable_live_video_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule Self-Guided Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "scheduletourintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Schedule a tour at </h2><h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "site-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemapintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Our Community Property Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tours of <span data-type=\"field-token\" data-field=\"property_address_city\"></span> Townhomes and Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_name\"></span> From Wherever You Are</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplansintro.body": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span>, we offer a variety of spacious floor plans designed to fit your lifestyle. Whether you're looking for a cozy one or a more expansive two bedroom apartment, each layout features modern finishes and plenty of natural light. With top-tier amenities and a prime location, you're sure to find the perfect space. Ready to find your dream apartment? Apply today and make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new place to call home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodintro.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Located in northeast North Las Vegas, Prosper 207 offers easy access to recreation, entertainment and everyday essentials. Catch a race or festival at Las Vegas Motor Speedway, spend an afternoon at Craig Ranch Regional Park, or get to Nellis Air Force Base in minutes. With everything you need close by, Prosper 207 provides one of the best apartment living experiences in North Las Vegas, NV.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Deposit - $350/pet</p><p>Pet Rent - $35/pet/month</p><p>*maximum two pets per home</p><p>Contact us to learn more about breed and size restrictions.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Our one-bedroom, one-bath layout makes the most of 731 square feet, with an open living area that flows easily into the kitchen. A private bedroom keeps rest separate from everyday living, so it's an easy, comfortable fit for solo residents or couples. Compare layouts on our <a href=\"/floor-plans\">floor plans</a> page.</p>",
    "mappedField": null
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At 989 square feet, the two-bedroom, two-bath home gives everyone room to spread out. Each bedroom has its own bath, which works well for roommates, guests, or a dedicated home office, and the shared living and dining space sits at the center of the home. Take a look inside through our <a href=\"/virtual-tour\">virtual tours</a>.</p>",
    "mappedField": null
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>This layout gives you more room for everyday life, with a living area big enough for both relaxing and entertaining. A well-planned kitchen and comfortable bedrooms help the home feel organized and easy to live in.</p>",
    "mappedField": null
  },
  "tabbedcallouts.panel4_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Our most spacious option is built for households that need room to grow, with open gathering space for meals, movie nights, and time together. Generous bedrooms and plenty of storage let everyone settle in comfortably. See the details on our <a href=\"/floor-plans\">floor plans</a> page.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.contact_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167735/01a0825f-1887-77ef-8c0f-15ebe8750052.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A cute Corgi puppy enjoys being petted while resting on a comfortable sofa indoors."
      }
    }
  },
  "petpolicy.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167736/01a0d541-052b-74d9-afab-8b68c3bc5230.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Close-up of a tabby cat with a collar resting on a wooden floor, looking contemplative."
      }
    }
  },
  "preferred-employer-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167736/01a09104-10a1-7462-ae53-c3a52c92ba8a.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A diverse team happily celebrates a workplace achievement with high-fives."
      }
    }
  },
  "reviews-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167736/01a09103-a62d-708d-9381-1555e2d1fdb7.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A joyful family moment with a father, mother, and child embracing lovingly on a cozy sofa."
      }
    }
  },
  "scheduletourintro.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule Self-Guided Tour"
      }
    }
  },
  "amenitiesfeatures.apartmentBannerImage": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "amenitiesfeatures.communityBannerImage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9c-fc2b-761e-8fcb-cf2745fc0bd8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Couple enjoying cocktails in a swimming pool at sunset."
      }
    }
  },
  "amenitiesintro.image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "amenitieslist.card0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Sparkling Swimming Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9c-fc2b-761e-8fcb-cf2745fc0bd8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Couple enjoying cocktails in a swimming pool at sunset."
      }
    }
  },
  "amenitieslist.card1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Center"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-371a-7349-a661-06b071d6c2d2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Woman running on treadmill in apartment complex gym"
      }
    }
  },
  "amenitieslist.card2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "On-Site Playground"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-428f-76fc-a766-ae2eecd57590.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment building exterior with a playground and parking spaces."
      }
    }
  },
  "amenitieslist.card3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pet-Friendly Community"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9c-fee4-74ce-ae37-8db5bf92d8a7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Man relaxing on a couch listening to music"
      }
    }
  },
  "amenitieslist.card4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Landscaped Grounds"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-11eb-7242-96ee-29323a68a897.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two happy border collies sitting on grass with mouths open"
      }
    }
  },
  "amenitieslist.card5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Convenient On-Site Parking"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-437f-710e-a17c-27b73470ecbf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern apartment building with balconies and landscaping."
      }
    }
  },
  "amenitieslist.card6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Work-From-Home Friendly"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-3334-7454-8c79-476040a8c4b6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a modern apartment complex with a swimming pool and surrounding landscaping."
      }
    }
  },
  "amenitieslist.card7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Comfortable Living Spaces"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-2770-7431-a0cb-7f6186d84ccb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Three friends enjoying a meal at a restaurant, laughing and eating."
      }
    }
  },
  "discoveramenities.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-371a-7349-a661-06b071d6c2d2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Woman running on treadmill in apartment complex gym"
      }
    }
  },
  "fullbleedstripe.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-437f-710e-a17c-27b73470ecbf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a modern apartment building with balconies and landscaping."
      }
    }
  },
  "neighborhoodintro.imagebottom": {
    "sourceIndex": 13,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-04ad-7118-9806-930d9075a0a6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Five friends sit on a ridge overlooking a mountain range, sharing photos."
      }
    }
  },
  "neighborhoodintro.imagetop": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "preferredemployerintro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-2d17-7322-b8e1-29ca91e09dce.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Cozy living room with a sofa, throw blanket, and decorative pillows."
      }
    }
  },
  "propertyoverview.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-3334-7454-8c79-476040a8c4b6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a modern apartment complex with a swimming pool and surrounding landscaping."
      }
    }
  },
  "tabbedcallouts.panel1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-2d17-7322-b8e1-29ca91e09dce.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Cozy living room with a sofa, throw blanket, and decorative pillows."
      }
    }
  },
  "tabbedcallouts.panel2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-13d0-710a-a348-adb677eaecbd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A desk with a laptop and plant bathed in sunlight"
      }
    }
  },
  "tabbedcallouts.panel3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9d-08b1-72d8-98ff-815086131293.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Person relaxing in bed with a cat on their lap, a book, and a cup of coffee."
      }
    }
  },
  "tabbedcallouts.panel4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167863/01a16a9c-fee4-74ce-ae37-8db5bf92d8a7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Man relaxing on a couch listening to music"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ]
};

export const styleOverrides = {};
